import { useState } from 'react';
import { Collapse } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import {
  FaqPaper,
  QuestionHeader,
  ExpandIconButton,
  AnswerBox,
  QuestionText,
  AnswerText,
} from './styles';

const FaqItem = ({
  question,
  answer,
  defaultExpanded = false,
  isExpanded: controlledExpanded,
  onToggle,
  sx,
  paperSx,
  questionSx,
  answerSx,
  iconSize = 'small',
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);

  const isControlled = controlledExpanded !== undefined;
  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleToggle = () => {
    if (isControlled) {
      onToggle?.();
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <FaqPaper
      elevation={0}
      sx={{
        maxHeight: isExpanded ? '500px' : '84px',
        ...paperSx,
      }}
    >
      <QuestionHeader onClick={handleToggle} sx={sx}>
        <QuestionText sx={questionSx}>{question}</QuestionText>

        <ExpandIconButton
          isExpanded={isExpanded}
          aria-label={isExpanded ? 'Collapse answer' : 'Expand answer'}
        >
          {isExpanded ? <RemoveIcon fontSize={iconSize} /> : <AddIcon fontSize={iconSize} />}
        </ExpandIconButton>
      </QuestionHeader>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <AnswerBox>
          <AnswerText sx={answerSx}>{answer}</AnswerText>
        </AnswerBox>
      </Collapse>
    </FaqPaper>
  );
};

export default FaqItem;
